var TYPE;

(function (TYPE2) {
  TYPE2[TYPE2["literal"] = 0] = "literal";
  TYPE2[TYPE2["argument"] = 1] = "argument";
  TYPE2[TYPE2["number"] = 2] = "number";
  TYPE2[TYPE2["date"] = 3] = "date";
  TYPE2[TYPE2["time"] = 4] = "time";
  TYPE2[TYPE2["select"] = 5] = "select";
  TYPE2[TYPE2["plural"] = 6] = "plural";
  TYPE2[TYPE2["pound"] = 7] = "pound";
  TYPE2[TYPE2["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));

var SKELETON_TYPE;

(function (SKELETON_TYPE2) {
  SKELETON_TYPE2[SKELETON_TYPE2["number"] = 0] = "number";
  SKELETON_TYPE2[SKELETON_TYPE2["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));

function isLiteralElement(el) {
  return el.type === TYPE.literal;
}

function isArgumentElement(el) {
  return el.type === TYPE.argument;
}

function isNumberElement(el) {
  return el.type === TYPE.number;
}

function isDateElement(el) {
  return el.type === TYPE.date;
}

function isTimeElement(el) {
  return el.type === TYPE.time;
}

function isSelectElement(el) {
  return el.type === TYPE.select;
}

function isPluralElement(el) {
  return el.type === TYPE.plural;
}

function isPoundElement(el) {
  return el.type === TYPE.pound;
}

function isTagElement(el) {
  return el.type === TYPE.tag;
}

function isNumberSkeleton(el) {
  return !!(el && typeof el === "object" && el.type === 0);
}

function isDateTimeSkeleton(el) {
  return !!(el && typeof el === "object" && el.type === 1);
}

export { SKELETON_TYPE, TYPE, isArgumentElement, isDateElement, isDateTimeSkeleton, isLiteralElement, isNumberElement, isNumberSkeleton, isPluralElement, isPoundElement, isSelectElement, isTagElement, isTimeElement };